angular.module('dnecom')
    .controller('SizeProfileController', ["$scope", "$http", "$timeout", "notifications", "wizardModal", "SizeProfileUtils", function($scope, $http, $timeout, notifications, wizardModal, SizeProfileUtils) {
        $scope.loading = false;
        $scope.error = false;
        $scope.sizeProfiles = [];

        $scope.tableInstance = {};
        $scope.dtInstanceCallback = function(dtInstance)
        {
            $scope.tableInstance = dtInstance;
        };

        $scope.searchTable = function(search) {
            $scope.tableInstance.DataTable.search(search);
            $scope.tableInstance.DataTable.draw();
        };

        $scope.dtSizeProfilesColumnDefs = [{
            targets: 3,
            width: '150px',
            orderable: false
        }];

        $scope.init = function() {
            $scope.getSizeProfiles();
        };

        $scope.getMeasurements = function (sizeProfile) {
            var m = sizeProfile.properties.measurementUnit;
            var measurements = [];

            if (m.hasOwnProperty('inch') && m.inch == 1) {
                measurements.push('Inches');
            }

            if (m.hasOwnProperty('cm') && m.cm == 1) {
                measurements.push('Centimeters');
            }

            return measurements.join(', ');
        };

        $scope.addSizeProfile = function() {
            $scope.editSizeProfile();
        };

        $scope.editSizeProfile = function(sizeProfile, index) {
            var add = false;
            if (!sizeProfile) {
                sizeProfile = SizeProfileUtils.create();
                add = true;
            }

            $scope.currentSizeProfile = angular.copy(sizeProfile);
            var sizeProfileModal = wizardModal.open({
                templateUrl: 'sizeProfileModal.html',
                size: 'lg',
                controller: 'SizeProfileModalController',
                resolve: {
                    sizeProfile: function() {
                        return $scope.currentSizeProfile;
                    }
                }
            });

            sizeProfileModal.result.then(function(response) {
                if (add) {
                    $scope.sizeProfiles.push(response.sizeProfile);
                } else {
                    $scope.updateSizeProfile(response.sizeProfile);
                }
            }, function() {
                if (index && !angular.equals($scope.currentSizeProfile, $scope.sizeProfiles[index])) {
                    $scope.sizeProfiles[index] = $scope.currentSizeProfile;
                }
            });
        };

        $scope.updateSizeProfile = function(sizeProfile) {
            for (var i in $scope.sizeProfiles) {
                if ($scope.sizeProfiles[i].id == sizeProfile.id) {
                    $scope.sizeProfiles[i] = sizeProfile;
                    return;
                }
            }
        };

        $scope.previewSizeProfile = function(sizeProfile) {
            wizardModal.open({
                templateUrl: 'sizeProfilePreviewModal.html',
                size: 'md',
                controller: function($scope, $uibModalInstance, sizeProfile) {
                    $scope.sizeProfileSelectedMeasurementUnit = null;
                    $scope.sizeProfile = sizeProfile;

                    $scope.setMeasurementUnit = function(unit) {
                        $scope.sizeProfileSelectedMeasurementUnit = unit;
                    };

                    $scope.close = function () {
                        $uibModalInstance.dismiss('close');
                    };

                    $scope.fetchColumnsNames = function(sizeProfile) {
                        return _.map(_.get(sizeProfile, 'sizes.0.values', []), function(sizeValue) {
                            return sizeValue.column;
                        });
                    };

                    $scope.isVisible = function(size) {
                        return _.some(size.values, function(sizeValue) {
                            return sizeValue.value.cm != '' || sizeValue.value.inch != '';
                        });
                    };

                    var setInitialMeasurementUnit = function() {
                        if ($scope.sizeProfile !== null) {
                            $scope.sizeProfileSelectedMeasurementUnit = $scope.sizeProfile.properties.measurementUnit.cm ? 'cm' : 'inch';
                        }
                    };

                    setInitialMeasurementUnit();
                },
                resolve: {
                    sizeProfile: function() {
                        return sizeProfile;
                    }
                }
            });
        };

        $scope.getSizeProfiles = function() {
            $scope.loading = true;
            $http.get(Routing.generate('size_profiles_get')).success(function(data) {
                if (data.hasOwnProperty('sizeProfiles')) {
                    $scope.sizeProfiles = data.sizeProfiles;
                } else {
                    notifications.danger('Request error.');
                }
            }).finally(function() {
                $timeout(function() {
                    $scope.loading = false;
                });
            });
        };

        $scope.getProfileUrl = function(sizeProfile) {
            return Routing.generate('properties', {
                id: sizeProfile.id
            });
        };

        $scope.getProfileColumnsCount = function (sizeProfile) {
            return SizeProfileUtils.getProfileColumns(sizeProfile).length;
        };

        $scope.deleteSizeProfile = function(sizeProfile) {
            $http.delete(Routing.generate('size_profile_delete', {
                    id: sizeProfile.id
                }))
                .then(function(response) {
                    if (response.data.success) {
                        $scope.getSizeProfiles();
                        notifications.success('Size profile has been deleted.');
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function(response) {
                    notifications.danger('Request error.');
                });
        };
    }]);
